import log from 'salvo-lite/log'

class beforeAndAfter {
    constructor (theme, elem) {
        log.debug('beforeAndAfter', 'Constructing', this)
        this._elem = elem
        this._controller = this.createController()
        this._images = this.getImages()
        this.attributes = this.setAttributes()
    }

    onInit () {
        this._elem.appendChild(this._controller.controllerElem)
        this.initiated()
    }

    initiated () {
        this._elem.classList.add('initiated')
    }

    createController () {
        log.debug('beforeAndAfter', 'Adding Controller')
        let retObj = {}
        retObj.controllerElem = document.createElement('div')
        retObj.controllerElem.classList.add('controller')
        retObj.controllerBtn = document.createElement('div')
        retObj.controllerBtn.classList.add('button')
        retObj.controllerArrowLeft = document.createElement('span')
        retObj.controllerArrowLeft.classList.add('arrow', 'arrow-left')
        retObj.controllerArrowRight = document.createElement('span')
        retObj.controllerArrowRight.classList.add('arrow', 'arrow-right')
        retObj.controllerBar = document.createElement('span')
        retObj.controllerBar.classList.add('bar')
        retObj.controllerBtn.appendChild(retObj.controllerArrowLeft)
        retObj.controllerBtn.appendChild(retObj.controllerBar)
        retObj.controllerBtn.appendChild(retObj.controllerArrowRight)
        retObj.controllerElem.appendChild(retObj.controllerBtn)
        this.addGrabEvent(retObj.controllerBtn)
        return retObj
    }

    getImages () {
        let retObj = {}
        retObj.beforeImg = this._elem.querySelector('.image-before')
        retObj.afterImg = this._elem.querySelector('.image-after')
        return retObj
    }

    setLeft (evt) {
        let clientX = evt.clientX || evt.touches[0].clientX
        this.position = clientX - this._elem.offsetLeft
        this.position = this.position < 0 ? 0 : this.position
        this.position = this.position > this._elem.offsetWidth ? this._elem.offsetWidth : this.position
        this._controller.controllerElem.style.left = this.position + 'px'
        this._images.beforeImg.style.width = this.position + 'px'
        log.debug('beforeAndAfter', 'Cursor Positon in element', this.position)
    }

    addGrabEvent (elem) {
        elem.addEventListener('mousedown', e => {
            log.debug('beforeAndAfter', 'Controller Activated')
            elem.classList.add('active')
            this.attributes.active = true
            log.debug('beforeAndAfter', 'Starting Cursor', e)
            log.debug('beforeAndAfter', 'Container', this)
            this.setLeft(e)
        })
        elem.addEventListener('touchstart', e => {
            log.debug('beforeAndAfter', 'Controller Activated')
            elem.classList.add('active')
            this.attributes.active = true
            log.debug('beforeAndAfter', 'Starting Cursor', e)
            log.debug('beforeAndAfter', 'Container', this)
            this.setLeft(e)
        })
        window.addEventListener('mousemove', e => {
            if (!this.attributes.active) return false
            log.debug('beforeAndAfter', 'Controller Moving')
            this.setLeft(e)
        })
        window.addEventListener('touchmove', e => {
            if (!this.attributes.active) return false
            log.debug('beforeAndAfter', 'Controller Moving', e)
            this.setLeft(e)
        })
        window.addEventListener('touchend', e => {
            if (!this.attributes.active) return false
            this.attributes.active = false
            elem.classList.remove('active')
            log.debug('beforeAndAfter', 'Controller Deactivated')
            log.debug('beforeAndAfter', 'Ending Cursor', e)
            log.debug('beforeAndAfter', 'Container', this)
        })
        window.addEventListener('mouseup', e => {
            if (!this.attributes.active) return false
            this.attributes.active = false
            elem.classList.remove('active')
            log.debug('beforeAndAfter', 'Controller Deactivated')
            log.debug('beforeAndAfter', 'Ending Cursor', e)
            log.debug('beforeAndAfter', 'Container', this)
            this.setLeft(e)
        })
    }

    setAttributes () {
        let retObj = {}

        retObj.active = false

        return retObj
    }
}

export default beforeAndAfter



// WEBPACK FOOTER //
// ./src/scripts/components/BeforeAndAfter.js